import { Link } from "react-router-dom";
import { Home, Search } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="container-store py-20 text-center" data-testid="not-found-page">
      <Seo title="Página não encontrada | HG Móveis" noindex />
      <p className="font-heading text-7xl font-bold text-brand">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-gray-900">Página não encontrada</h1>
      <p className="mt-2 text-sm text-gray-500 max-w-md mx-auto">
        O endereço que você tentou acessar não existe ou foi movido. Que tal voltar para a loja?
      </p>
      <div className="mt-6 flex justify-center gap-3">
        <Link to="/">
          <Button className="rounded-full" data-testid="notfound-home">
            <Home className="w-4 h-4" /> Página inicial
          </Button>
        </Link>
        <Link to="/produtos">
          <Button variant="outline" className="rounded-full" data-testid="notfound-catalog">
            <Search className="w-4 h-4" /> Ver produtos
          </Button>
        </Link>
      </div>
    </div>
  );
}
